export class LogitudeLookupModel {
    Id: number;
    Tenant: number;
    Name: string;
    ExternalId: string;
    Code: string;
    Type: string;
    City: string;
    CountryExternalId: string;
  }